import { Controller } from "stimulus";

const KEY_ESCAPE = 27;
const OPEN_CLASS = "modal--open";
const BODY_CLASS = "modal-open";

export default class extends Controller {
  connect() {
    if (this.isOpen()) {
      document.body.classList.add(BODY_CLASS);
    }
  }

  isOpen() {
    return this.element.classList.contains(OPEN_CLASS);
  }

  openModal() {
    document.body.classList.add(BODY_CLASS);
    this.element.nextElementSibling.classList.add(OPEN_CLASS);

    const event = new CustomEvent("modal-opened", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  closeModal() {
    document.body.classList.remove(BODY_CLASS);
    this.element.classList.remove(OPEN_CLASS);

    const event = new CustomEvent("modal-closed", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  keyHandler(event) {
    if (event.keyCode === KEY_ESCAPE) {
      this.closeModal();
    }
  }
}
